import BannerSection from "./BannerSection";
import AboutSection from "./AboutSection";
import MyBallroomSection from "./MyBallroomSection";
import VenueHighlightSection from "./VenueHighlightSection";
import HighlightsawardsSection from "./HighlightsawardsSection";
import TestimonialSection from "./TestimonialSection";
import VideosSection from "./VideosSection";
import UpcomingEventsSection from "./UpcomingEventsSection";
import BlogsSection from "./BlogsSection";
import FunFactSection from "./FunFactSection";

export const HomePage = () => {
  return (
    <>
      <BannerSection />
      <AboutSection />
      <MyBallroomSection />
      <VenueHighlightSection />
      <FunFactSection/>
      <TestimonialSection id={1} />
      <HighlightsawardsSection />
      <VideosSection id={1} />
      <UpcomingEventsSection />
      <BlogsSection id={0} />
    </>
  );
};
